import React from 'react';
import { promotionRule, tiers } from '../../data/architecture';
const toneMap = {
  olive: 'bg-olive',
  opal: 'bg-opal',
  peach: 'bg-peach'
};
export function PageTiers() {
  return <section aria-labelledby="tiers-h" className="border-t border-line bg-white" data-id="element-273" data-mp="4j8chpfs5okp">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-274" data-mp="3vprxtyj8swx9">
        <p className="label text-olive" data-id="element-275" data-mp="3vqkta3cr4003">Step two · The answer to “is it worth it?”</p>
        <h2 id="tiers-h" className="mt-6 max-w-3xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-276" data-mp="380qirsfwmnj0">
          Not everything deserves a page
        </h2>
        <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-muted" data-id="element-277" data-mp="3hrbf1983vfyr">
          Yes, keep the individual pages — your analytics are unambiguous that
          they work, holding attention five times longer than any hub. But you
          are not building two hundred of them. Three tiers, and most things
          never leave tier two.
        </p>

        <div className="mt-16 grid gap-x-16 gap-y-14 lg:grid-cols-3" data-id="element-278" data-mp="3rzs4cz6z0cmi">
          {tiers.map(tier => <article key={tier.tier} className="border-t border-line pt-9" data-id="element-279" data-mp="rnoh0h71lc3">
              <span className={`block h-2 w-16 ${toneMap[tier.tone]}`} aria-hidden="true" data-id="element-280" data-mp="5jnrx2wh2wdf" />
              <p className="mt-7 font-display text-[34px] font-300 leading-none text-ink/35" data-id="element-281" data-mp="9jpowyr9j1md">
                {tier.tier}
              </p>
              <h3 className="mt-4 font-display text-[30px] font-300 leading-tight text-ink" data-id="element-282" data-mp="392h2d6tyf53d">
                {tier.name}
              </h3>
              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-1" data-id="element-283" data-mp="3i0ja05870vzm">
                <p className="label text-olive" data-id="element-284" data-mp="3mzvvomnbvx0m">{tier.effort}</p>
                <p className="label text-muted/80" data-id="element-285" data-mp="3n174j0vmruyl">{tier.volume}</p>
              </div>
              <p className="mt-6 text-[15px] leading-[1.85] text-ink/80" data-id="element-286" data-mp="xa22oq96vskv">
                {tier.test}
              </p>
              <h4 className="label mt-9 text-muted" data-id="element-287" data-mp="12brew985ecaj">What’s on it</h4>
              <ul className="mt-4 space-y-2.5" data-id="element-288" data-mp="2ybi1m9z4g79y">
                {tier.contains.map(c => <li key={c} className="flex gap-3.5 text-[14px] leading-relaxed text-muted" data-id="element-289" data-mp="2uag1lqxdrr6x">
                    <span className="mt-2.5 h-1 w-1 shrink-0 bg-olive" aria-hidden="true" data-id="element-290" data-mp="33bwatvcgln9k" />
                    {c}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-20 max-w-3xl border-l-2 border-olive pl-8" data-id="element-291" data-mp="2anqoj45rbq7m">
          <h3 className="font-display text-[30px] font-300 leading-tight text-ink" data-id="element-292" data-mp="2pc4rdf36beo6">
            {promotionRule.title}
          </h3>
          <p className="mt-4 text-[16px] leading-[1.85] text-ink/80" data-id="element-293" data-mp="2kl4to7m8cskm">
            {promotionRule.body}
          </p>
        </div>
      </div>
    </section>;
}